import AdRecruitSelectType from './AdRecruitSelectType'
import AdRecruitSelectStatus from './AdRecruitSelectStatus'
import styled from 'styled-components'
import { NextButton } from '../common/CommonStyled'
import AddIcon from '@mui/icons-material/Add';
import Recruit_ScheduleTable from './Recruit_ScheduleTable'
import { useAdRecruitStore } from 'src/stores/AdRecruitStore'
import { useModalStore } from 'src/stores/ModalStore'
import ModalTitleAddSchedule from './ModalTitleAddSchedule'
import ModalContentAddSchedule from './ModalContentAddSchedule'

const PageWrapper = styled.div`
    padding: 20px;
`
const TopWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
`
const DropBoxWrapper = styled.div`
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
`

const Recruit_Schedule = () => {
    const data = useAdRecruitStore((state)=>state.recruitScheduleData)
    const modalSetField = useModalStore((state)=>state.setField)
    
    const onClickAddSchedule = ()=>{
        modalSetField('type','CENTER')
        modalSetField('width','1024px')
        modalSetField('title', <ModalTitleAddSchedule/>)
        modalSetField('content',<ModalContentAddSchedule/>)
        modalSetField('open',true)
    }

    return (
        <PageWrapper>
            <TopWrapper>
                <DropBoxWrapper>
                    <AdRecruitSelectType/>
                    <AdRecruitSelectStatus/>
                </DropBoxWrapper>
                    <NextButton style={{width:'120px',maxHeight:'47px'}} onClick={onClickAddSchedule}>
                        <div style={{display:'flex',justifyContent:'center', alignItems:'center', gap:'8px'}}>
                            <AddIcon/> 일정등록
                        </div>
                    </NextButton>
            </TopWrapper>
            <Recruit_ScheduleTable propsData={data}/>
        </PageWrapper>
    )
}

export default Recruit_Schedule